const isDev = process.env.NODE_ENV === "development";

const getApiBase = () => {
  const envUrl =
    process.env.REACT_APP_KAY_API_BASE_URL ||
    process.env.REACT_APP_PUBLIC_API_BASE_URL;
  if (envUrl) {
    return envUrl.replace(/\/+$/, "");
  }
  return isDev ? "" : "https://backend-api.konn3ct.ng";
};

const buildApiUrl = (endpoint) => {
  const base = getApiBase();
  const cleanEndpoint = endpoint.startsWith("/") ? endpoint : `/${endpoint}`;
  const apiPath = cleanEndpoint.startsWith("/api/") ? cleanEndpoint : `/api${cleanEndpoint}`;
  return base ? `${base}${apiPath}` : apiPath;
};

export const detectVisitorCountry = async ({ signal } = {}) => {
  const endpoint = buildApiUrl("/v1/geo/detect");

  console.log(
    `[GeoService] 🚀 detectVisitorCountry() called. Fetching from endpoint: ${endpoint}`
  );

  try {
    const response = await fetch(endpoint, {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
      cache: "no-store",
      signal,
    });

    console.log("[GeoService] 📥 HTTP Response Status:", response.status, response.statusText);

    let body = null;
    try {
      body = await response.json();
    } catch (parseErr) {
      console.error("[GeoService] ❌ Failed to parse JSON response:", parseErr);
    }

    console.log("[GeoService] 📦 Raw Backend Response Body:", body);

    if (!response.ok) {
      throw new Error(
        body?.message || `Country detection failed with HTTP ${response.status}`
      );
    }

    if (!body?.country_code) {
      throw new Error("Country detection response did not include country_code.");
    }

    const result = {
      detectedCountryCode: String(body.country_code).toUpperCase(),
      suggestedCurrency: body.currency
        ? String(body.currency).toUpperCase()
        : null,
      source: body.source || "unknown",
    };

    console.log("[GeoService] ✅ Successfully resolved country:", result);
    console.log(
      `[GeoService] 🔍 Backend resolution source: "${result.source}" — ` +
      (result.source === "cloudflare" ? "Priority 1: Cloudflare CF-IPCountry header" :
       result.source === "maxmind"    ? "Priority 2: MaxMind GeoIP2 database" :
       result.source === "ipapi.co"   ? "Priority 3a: ipapi.co HTTP API" :
       result.source === "ip-api.com" ? "Priority 3b: ip-api.com HTTP API" :
       result.source === "fallback"   ? "Priority 4: Default fallback (no geo provider matched)" :
       `Unknown source "${result.source}"`)
    );
    return result;
  } catch (error) {
    console.error("[GeoService] ❌ Error in detectVisitorCountry():", error);
    throw error;
  }
};
